import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";

function LanguageHandler() {
    const { i18n } = useTranslation();
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const urlLang = params.get("lang");
        const savedLang = localStorage.getItem("lang");

        // Priority: URL param -> localStorage -> i18n default
        const lang = urlLang || savedLang || i18n.language;

        if (i18n.language !== lang) {
            i18n.changeLanguage(lang);
        }

        document.documentElement.lang = lang;
        localStorage.setItem("lang", lang); // save last used language

        // If no param, update URL for bookmarking/sharing
        if (!urlLang) {
            params.set("lang", lang);
            navigate(`${location.pathname}?${params.toString()}`, { replace: true });
        }
    }, [location.search, i18n, navigate]);

    return null;
}

export default LanguageHandler;
